import { Injectable } from '@angular/core';
import { CustomerProjectPhaseReply } from '../../customer-project-phase-reply.interface';
import { ApiService } from '../api/api.service';

@Injectable({
    providedIn: 'root',
})
export class CustomerProjectPhaseReplyService {
    constructor(private apiService: ApiService) {}

    save(reply: CustomerProjectPhaseReply) {
        return this.apiService.postCall$<CustomerProjectPhaseReply[]>(`customer-projects/phases/reply`, reply);
    }

    delete(id: number) {
        return this.apiService.deleteCall$<CustomerProjectPhaseReply[]>(`customer-projects/phases/reply/${id}`);
    }
}
